/**
 * Public read + draft preview for entertainment-events (collection uses drafts).
 *
 * @param {import('@payloadcms/live-preview').CollectionPopulationRequestHandlerArgs} args
 */
export async function entertainmentLivePreviewRequestHandler({
  apiPath,
  data,
  serverURL,
}) {
  const incoming = data?.data;
  const docId = incoming?.id;

  if (!docId) {
    return new Response(JSON.stringify(incoming ?? {}), {
      status: 200,
      headers: { "Content-Type": "application/json" },
    });
  }

  const url = `${serverURL}${apiPath}/entertainment-events/${docId}?draft=true`;
  return fetch(url, {
    body: JSON.stringify(data),
    headers: {
      "Content-Type": "application/json",
      "X-Payload-HTTP-Method-Override": "GET",
    },
    method: "POST",
  });
}
